import { List, ListItem, ListItemProps } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import React from 'react';
import CustomTypography, {
    TypographyType,
} from '../Typography/CustomTypography';
import './ListStyle.scss';

export interface IBulletListProps extends Omit<ListItemProps, 'key' | 'dense'> {
    bulletItems: string[];
    listId?: string;
    button?: boolean;
}

function BulletList({
    listId,
    bulletItems,
    button,
    ...others
}: IBulletListProps): JSX.Element {
    return (
        <List id={listId}>
            {bulletItems.map((textItem: string, index: number) => {
                return (
                    <ListItem
                        dense={false}
                        key={`bullet-list-item-${index}`}
                        {...others}
                    >
                        <FiberManualRecord className={'bulletPoint'} />
                        <CustomTypography
                            textAlign="left"
                            type={TypographyType.notoSansBody16px}
                            text={textItem.trim()}
                        />
                    </ListItem>
                );
            })}
        </List>
    );
}

export default BulletList;
